const enterpriseAbilityRouter = {
  path: 'enterprise-ability',
  name: '',
  component: () => import('@/apps/open/views/fileCenter/components/FileRouter.vue'),
  meta: { title: '' },
  children: [
    {
      path: 'team',
      redirect: 'team/introduce',
      name: '',
      component: () => import('@/apps/open/views/fileCenter/components/FileRouter.vue'),
      meta: { title: '企业团队' },
      children: [
        {
          path: 'introduce',
          name: '',
          component: () => import('@/apps/open/views/fileCenter/components/FileContent.vue'),
          meta: { title: '产品介绍', mdfilepath: '/enterpriseability/team/Introduce.md', aimtilelist: ['产品介绍'] }
        },
        {
          path: 'quick-access',
          name: '',
          component: () => import('@/apps/open/views/fileCenter/components/FileContent.vue'),
          meta: { title: '快速接入', mdfilepath: '/enterpriseability/team/QuickAccess.md', aimtilelist: ['创建应用', '申请权限', '接口说明'] }
        },
        {
          path: 'ordteam-api',
          name: '',
          component: () => import('@/apps/open/views/fileCenter/components/FileContent.vue'),
          meta: { title: '普通团队Api列表', mdfilepath: '/enterpriseability/team/OrdTempApiList.md', aimtilelist: ['接口目录'] }
        },
        {
          path: 'depteam-api',
          name: '',
          component: () => import('@/apps/open/views/fileCenter/components/FileContent.vue'),
          meta: { title: '部门团队Api列表', mdfilepath: '/enterpriseability/team/DepTempApiList.md', aimtilelist: ['接口目录'] }
        }
      ]
    },
    {
      path: 'order',
      redirect: 'order/introduce',
      name: '',
      component: () => import('@/apps/open/views/fileCenter/components/FileRouter.vue'),
      meta: { title: '企业订单' },
      children: [
        {
          path: 'introduce',
          name: '',
          component: () => import('@/apps/open/views/fileCenter/components/FileContent.vue'),
          meta: { title: '产品介绍', mdfilepath: '/enterpriseability/order/Introduce.md', aimtilelist: ['产品介绍', '产品流程'] }
        },
        {
          path: 'quick-access',
          name: '',
          component: () => import('@/apps/open/views/fileCenter/components/FileContent.vue'),
          meta: { title: '快速接入', mdfilepath: '/enterpriseability/order/QuickAccess.md', aimtilelist: ['创建应用', '申请权限', '接口说明'] }
        },
        {
          path: 'api-list',
          name: '',
          component: () => import('@/apps/open/views/fileCenter/components/FileContent.vue'),
          meta: { title: 'Api列表', mdfilepath: '/enterpriseability/order/ApiList.md', aimtilelist: ['接口目录'] }
        }
      ]
    },
    {
      path: 'addressbook',
      redirect: 'addressbook/introduce',
      name: '',
      component: () => import('@/apps/open/views/fileCenter/components/FileRouter.vue'),
      // component: () => import('@/apps/open/views/fileCenter/enterpriseAbility/addressBook/index.vue'),
      meta: { title: '企业通讯录' },
      children: [
        {
          path: 'introduce',
          name: '',
          component: () => import('@/apps/open/views/fileCenter/components/FileContent.vue'),
          meta: { title: '产品介绍', mdfilepath: '/enterpriseability/addressbook/Introduce.md', aimtilelist: ['产品介绍', '产品流程'] }
        },
        {
          path: 'quick-access',
          name: '',
          component: () => import('@/apps/open/views/fileCenter/components/FileContent.vue'),
          meta: { title: '快速接入', mdfilepath: '/enterpriseability/addressbook/QuickAccess.md', aimtilelist: ['创建应用', '申请权限', '接口说明'] }
        },
        {
          path: 'api-list',
          name: '',
          component: () => import('@/apps/open/views/fileCenter/components/FileContent.vue'),
          meta: { title: 'Api列表', mdfilepath: '/enterpriseability/addressbook/ApiList.md', aimtilelist: ['接口目录'] }
        }
      ]
    }
  ]
}

export default enterpriseAbilityRouter
